<template>
  <div>
    <titulo-notas />
    <filtro-notas
      @atualizar-filtro="atualizarFiltro"
      @filtrar="buscarNotasPorFiltro"
      @limpar-filtro="limparFiltro"
    />
    <tabela-notas :items="notas" @atualizar-notas="atualizarNota" />
    <div class="w-100 d-flex justify-content-between">
      <span></span>
      <b-button variant="info" @click="salvar" :disabled="notas.length === 0">
        {{ $t('GERAL.SALVAR') }}</b-button
      >
    </div>
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

// Components:
import TituloNotas from '@/views/academico/diario-classe/components/notas/TituloNotas';
import FiltroNotas from './components/notas/FiltroNotas';
import TabelaNotas from './components/notas/TabelaNota';

// services
import NotaService from '@/common/services/academico/nota.service.js';

export default {
  components: {
    TituloNotas,
    FiltroNotas,
    TabelaNotas,
  },
  data() {
    return {
      filtro: {},
      notas: [],
    };
  },
  methods: {
    atualizarFiltro(filtro) {
      this.filtro = filtro;
    },

    async buscarNotasPorFiltro() {
      try {
        this.$store.dispatch(START_LOADING);
        const { data } = await NotaService.obterPorFiltro(this.filtro);
        this.notas = data;
      } catch (err) {
        mensagem.showErrors(err);
      } finally {
        this.$store.dispatch(STOP_LOADING);
      }
    },

    async salvar() {
      let padraoNuloId = '00000000-0000-0000-0000-000000000000';

      const criacao = [];
      const atualizar = [];

      this.notas.forEach((item) => {
        item.id === padraoNuloId ? criacao.push(item) : atualizar.push(item);
      });

      try {
        const promises = [];

        if (criacao.length) promises.push(this.criar(criacao));

        if (atualizar.length) promises.push(this.atualizar(atualizar));

        await Promise.all(promises);

        mensagem.sucesso(
          this.$t('GERAL.SUCESSO'),
          this.$t('Pontos atualizados com sucesso')
        );

        this.buscarNotasPorFiltro();
      } catch (error) {
        mensagem.showErrors(error);
      }
    },

    async criar(notas) {
      try {
        this.$store.dispatch(START_LOADING);
        await NotaService.criar(notas);
      } catch (error) {
        mensagem.showErrors(error);
      } finally {
        this.$store.dispatch(STOP_LOADING);
      }
    },

    async atualizar(notas) {
      try {
        this.$store.dispatch(START_LOADING);
        await NotaService.editar(notas);
      } catch (error) {
        mensagem.showErrors(error);
      } finally {
        this.$store.dispatch(STOP_LOADING);
      }
    },

    atualizarNota(notas) {
      this.notas = notas;
    },

    limparFiltro() {
      this.notas = [];
    },
  },
};
</script>
